import React from "react";

const ArrowLeftIcon = ({ className, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 20"
      className={className ? className : "w-[20px] h-[20px]"}
      {...rest}
    >
      <g clipPath="url(#clip0_5624_71880)">
        <path
          fill="currentColor"
          d="m.509 9.267 6.809-6.81c.194-.194.453-.3.73-.3s.535.106.73.3l.618.619a1.045 1.045 0 0 1 0 1.468l-3.973 3.98h12.62c.57 0 1.02.446 1.02 1.015v.875c0 .569-.45 1.06-1.02 1.06H5.379l4.018 4.003c.194.194.3.446.3.723s-.106.532-.3.726l-.619.616c-.194.194-.453.3-.73.3s-.535-.107-.73-.301L.509 10.73a1.02 1.02 0 0 1-.3-.731c-.001-.278.106-.539.3-.733"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_5624_71880">
          <path fill="#fff" d="M19.063.572H.207v18.855h18.855z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default ArrowLeftIcon;
